import React from 'react';
import { useTranslation } from 'react-i18next';

const CookiePreferencesLink = () => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="cookie-preferences-launch"
      onClick={() => window.dispatchEvent(new Event('aipsyhelp:open-cookie-preferences'))}
    >
      {t('footer.cookie_notice', t('cookies.manage', 'Cookie notice'))}
    </button>
  );
};

export default CookiePreferencesLink;
